module.exports = ".input-editar{\n  color: #006DA1;\n  font-size: 12px;\n  margin-top: 50px;\n  width: 100px;\n  margin-left: -20px;\n}\n\n.input-link{\n  text-decoration: none;\n}\n\n.input-label{\n  font-size: 15px;\n  color: #787878;\n  font-weight: 200;\n}\n\n.remove-padding{\n  padding-right: 0px;\n  padding-left: 0px;\n}\n\n@media (min-width: 1000px) {\n  .input-label{\n    font-size: 18px;\n  }\n}\n\n@media (min-width: 1450px) {\n\n  .input-label{\n    font-size: 20px;\n  }\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/endereco/endereco.component.css
// module id = ./src/app/endereco/endereco.component.css
// module chunks = main